export const uk = {
    'rejected-on-moderation': 'Не прошла модерацию'
};
